// extracted by mini-css-extract-plugin
export var card = "_qf-0";
export var content = "_qf-2";
export var details = "_qf-3";
export var icon = "_qf-1";
export var iconBlue = "_qf-5";
export var iconBrand = "_qf-4";
export var iconGrayBlue = "_qf-6";
export var iconGreen = "_qf-7";
export var iconIndigo = "_qf-8";
export var iconOrange = "_qf-9";
export var iconPurple = "_qf-a";
export var iconRed = "_qf-b";
export var iconWarning = "_qf-c";